var moduleMap = {
	"./AppPadSales": () => {
		return Promise.all([__webpack_require__.e(9834), __webpack_require__.e(3187), __webpack_require__.e(1087), __webpack_require__.e(9693), __webpack_require__.e(7963), __webpack_require__.e(3285), __webpack_require__.e(5948), __webpack_require__.e(3664), __webpack_require__.e(2421), __webpack_require__.e(9505), __webpack_require__.e(3855), __webpack_require__.e(3655), __webpack_require__.e(8061)]).then(() => (() => ((__webpack_require__(28061)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});